import React from "react";
import styled from "styled-components";
import NetworkObj from "img/networkobjects.svg";
import PrimaryButton from "./PrimaryButtonOutline";
import Retry from "img/retrybtn.svg";

const Container = styled.div`
  text-align: center;
  overflow: hidden;
  ${({ customClass }) =>
    customClass &&
    `
    position: absolute;
    top: 62%; 
    left: 50%;
    transform: translate(-50%, -50%);
  `}
`;

const IllustrationImage = styled.img`
  position: relative;
  width: 158px;
  height: 100px;
  ${({ customClass }) =>
    customClass &&
    `
    width:158px;
    height: 100px;
  `}
  ${({ customClassSmall }) =>
    customClassSmall &&
    `
    width:158px;
    height:158px;
  `}
`;

const OverlayContent = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  flex-direction: column;
`;

const Title = styled.span`
  font-weight: 700;
  color: #203662;
  font-size: 14px;
  margin-top: 20px;
`;

const Description = styled.span`
  margin-top: 2px;
  display: block;
  font-size: 12px;
`;
const BtnBox = styled.div`
  margin-top: 20px;
`;
const NetworkErr = ({
  title,
  description,
  showButton = false,
  buttonText,
  buttonIcon,
  onButtonClick,
  customClass,
  customClassSmall,
  customClassNoResult,
  ...props
}) => {
  return (
    <Container customClass={customClass} className="btnVhCenter" {...props}>
      <IllustrationImage
        src={NetworkObj}
        alt="No Data Illustration"
        customClass={customClass}
        customClassSmall={customClassSmall}
      />

      <OverlayContent customClassNoResult={customClassNoResult}>
        {title && <Title>{title}</Title>}

        {description && <Description>{description}</Description>}

        {showButton && onButtonClick && (
          <BtnBox>
            <PrimaryButton
              isgenai={true}
              showIcon={true}
              icon={Retry}
              title={"Try Again"}
              handleClick={onButtonClick}
            />
          </BtnBox>
        )}
      </OverlayContent>
    </Container>
  );
};

export default NetworkErr;
